module.exports = __webpack_public_path__ + "img/PXL_20230523_142022493.f2212a9e.jpg";